import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { HolidayTypeEnum } from '@qaroni-app/holidays/types/holiday-type.enum';
import { WorkCalendarSnackbarData } from '@qaroni-app/work-calendar/types/work-calendar-snackbar-data';

@Component({
  selector: 'qaroni-holidays-details-snackbar',
  templateUrl: './holidays-details-snackbar.component.html',
  styleUrl: './holidays-details-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HolidaysDetailsSnackbarComponent {
  snackBarRef =
    inject<MatSnackBarRef<HolidaysDetailsSnackbarComponent>>(MatSnackBarRef);
  data = inject<WorkCalendarSnackbarData>(MAT_SNACK_BAR_DATA);

  get ngPanelClass() {
    switch (this.data.type) {
      case HolidayTypeEnum.NATIONAL:
        return 'bg-accent text-white';
      case HolidayTypeEnum.LOCAL:
        return 'bg-tertiary text-white';
      case HolidayTypeEnum.INTERNAL:
        return 'bg-primary-40 text-white';
      case HolidayTypeEnum.REGIONAL:
        return 'bg-secondary text-white';
      default:
        return 'bg-white text-black';
    }
  }

  get icon() {
    return this.data.icon ? this.data.icon : 'event';
  }

  get holidayType() {
    return this.data.type ? this.data.type : HolidayTypeEnum.NATIONAL;
  }
}
